import React, { useState, useEffect, useRef } from 'react';
import assetsCompareServices from './assetsCompareServices';
import Pagination from '../../Header/Pagination';

export default function KorrectDelivery() {

    let [searchFor, setsearchFor] = useState("");
    let [totalRows, setTotalRows] = useState(0);
    let [AssetType, setAssetType] = useState("trackRelease");
    let [assetListing, setAssetListing] = useState<any[]>([]);

    var payload = { PageNumber: 1, PageSize: 10, ExcludeExisting: "0" }
    const apiSearch = (searchFor: any) => {

        if (AssetType === "trackRelease") {
            assetsCompareServices.KorrectReleaseTrackList(payload).then((res) => {
                setAssetListing(res);
                setTotalRows(res && res[0] && res[0].totalRows ? res[0].totalRows : 0)
            });
        }

        if (AssetType === "trackReleaseMin") {
            assetsCompareServices.trackReleaseMin(payload).then((res) => {
                setAssetListing(res);
                setTotalRows(res && res[0] && res[0].totalRows ? res[0].totalRows : 0)
            });
        }

        if (AssetType === 'songs') {
            assetsCompareServices.KorrectSongListList(payload).then((res) => {
                setAssetListing(res);
                setTotalRows(res && res[0] && res[0].totalRows ? res[0].totalRows : 0)
            });
        }
    }

    let [selectIndex, setSelectIndex] = useState(null)
    const resetDropSelect = (index: any) => {

        if (selectIndex !== index) {
            selectIndex = index
            setSelectIndex(selectIndex)
        } else {
            selectIndex = null;
            setSelectIndex(selectIndex)
        }
    }

    const audioRef = useRef<HTMLAudioElement | null>(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const toggleAudio = (file: any) => {
        // If already playing, stop it
        if (audioRef.current && !audioRef.current.paused) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            setIsPlaying(false);
        } else {

            const audio = new Audio(
                'https://belladmin79162d682fba47ab97d7f177391e19b0164724-dev.s3.ap-southeast-1.amazonaws.com' + file
            );
            audioRef.current = audio;

            audio.play()
                .then(() => setIsPlaying(true))
                .catch((err) => console.error('Playback failed:', err));

            // Reset play state when audio ends
            audio.onended = () => setIsPlaying(false);
        }
    };


    const korrectExport = (AssetType: any) => {

        var payload = { "PageNumber": 1, "PageSize": 10, "ExcludeExisting": "0", "Export": 1  ,"type" : "KorrectSongExport" , "exportType" : "exportType"}
        if (AssetType === 'trackRelease') {
            payload.type = "FullKorrectReleaseTrackExport"
            payload.exportType = "FullKorrectReleaseTrackExport"
            assetsCompareServices.excelGenericExport(payload)//.then((res) => { setAssetListing(res) });
        }

        if (AssetType === 'trackReleaseMin') {
            payload.type = "MinKorrectReleaseTrackExport"
            payload.exportType = "MinKorrectReleaseTrackExport"
            assetsCompareServices.excelGenericExport(payload)//.then((res) => { setAssetListing(res) });
        }

        if (AssetType === 'songs') {
            payload.type = "KorrectSongExport"
            payload.exportType = "KorrectSongExport"
            assetsCompareServices.excelGenericExport(payload)//.then((res) => { setAssetListing(res) });
        }
    }

    const PaginationList =(e:any)=>{
        console.log(e)
        payload.PageNumber = e.pageNumber;
        payload.PageSize    = e.pageSize;
        apiSearch(searchFor);
        console.log(payload)
    }

    return (<>
        <div className="landing ws-12">

            <div className='ws-12 pLarge'>

                <div className="ws-12 ptxl mtl">
                    <span className="ws-12 text-bold text-xl">Korrect Asset</span>
                    <span className="ws-12 ptl text-bold text-m turquoise">Asset Listing</span>
                </div>

                <div className='ws-12'>
                    <ul className="nav nav-tabs p0 m0 pull-right">
                        <li className={AssetType === "trackRelease" ? "m0 mt mr borderNone plxl prxl active" : "m0 mt mr plxl prxl"} onClick={() => { AssetType = 'trackRelease'; setAssetType(AssetType); apiSearch(searchFor) }}>Full Track Release</li>
                        <li className={AssetType === "trackReleaseMin" ? "m0 mt mr borderNone plxl prxl active" : "m0 mt mr plxl prxl"} onClick={() => { AssetType = 'trackReleaseMin'; setAssetType(AssetType); apiSearch(searchFor) }}>Minimum Track Release</li>
                        <li className={AssetType === "songs" ? "m0 mt mr borderNone plxl prxl active" : "m0 mt mr plxl prxl"} onClick={() => { AssetType = 'songs'; setAssetType(AssetType);; apiSearch(searchFor) }}>Songs</li>
                    </ul>
                </div>

                <div className="ws-12 ptxl">

                    <div className="ws-10 mbl">
                        <button className="btn white pLarge bg-level14 m0 ws-2" onClick={() => apiSearch(searchFor)}> Search</button>
                        <input type="text" value={searchFor} onChange={(e) => setsearchFor(e.target.value)} className="pLarge ws-10 m0 heightReset" placeholder="Type to search" />
                    </div>

                    <button className="white m0 bg-level7 pm  btn-m pull-right pLarge ws-1" onClick={() => korrectExport(AssetType)}>Export </button>

                </div>

                <h2 className="pull-left capitalize  m0"> Search results: {totalRows} </h2>

                {AssetType === "trackRelease" && assetListing.length > 0 && <div className='ws-12 mtl pLarge tableVertical'>

                    <table className={'bgWhite table tablePresentation'}>
                        <thead>
                            <tr>
                                <th className="text-Left">UPC</th>
                                <th className="text-Left">Catalog Number</th>
                                <th className="text-Left">Release Title</th>
                                <th className="text-Left">Release Artist</th>
                                <th className="text-Left">Release Label</th>
                                <th className="text-Left">Release Format</th>
                                <th className="text-Left">CustomID</th>
                                <th className="text-Left">Picture</th>
                                <th className="text-Left">Tracks</th>
                            </tr>
                        </thead>
                        <tbody>

                            {assetListing?.map((list: any, index: any) => {
                                return (

                                    <>
                                        <tr className='bg-level1'>
                                            <td>{list.upc}</td>
                                            <td>{list.catalogNumber}</td>
                                            <td>{list.name}</td>
                                            <td>{list.artist}</td>
                                            <td>{list.label}</td>
                                            <td>{list.format}</td>
                                            <td>{list.customID}</td>
                                            <td><img alt="Korrect"  className="pull-none" src={'https://belladmin79162d682fba47ab97d7f177391e19b0164724-dev.s3.ap-southeast-1.amazonaws.com' + list.picture} width={60} /></td>
                                            <td>
                                                <button className='icon-btn edit btn-xs m0' onClick={() => resetDropSelect(index)} disabled={!list?.trackList?.[0]}>
                                                    <i className={selectIndex === index ? "icon-arrow-up m0" : "icon-arrow-down m0"}></i>
                                                </button>

                                            </td>
                                        </tr>

                                        {selectIndex === index && <>

                                            <tr>
                                                <td colSpan={8}>

                                                    <table className={'bgWhite table tablePresentation'}>
                                                        <thead>
                                                            <tr>
                                                                <th className="text-Left">ISRC</th>
                                                                <th className="text-Left">Tracks Title</th>
                                                                <th className="text-Left">Tracks Artist</th>
                                                                <th className="text-Left">Sequence</th>
                                                                <th className="text-Left">Sound</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        </tbody>
                                                        {list?.trackList?.map((value: any) => {

                                                            return (

                                                                <tr>
                                                                    <td>{value.ISRC}</td>
                                                                    <td>{value.trackTitle}</td>
                                                                    <td>{value.tartist}</td>
                                                                    <td>{value.sequence}</td>
                                                                    <td className='text-center'>

                                                                        <button className="icon-btn edit" onClick={() => toggleAudio(value.file)} disabled={!value.file}>
                                                                            {isPlaying ? 'Stop' : 'Play'} Sound
                                                                        </button>

                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                        }

                                                    </table>

                                                </td>

                                            </tr></>
                                        }

                                    </>
                                )

                            })}

                        </tbody>
                    </table>
                </div>}

                {AssetType === "trackReleaseMin" && assetListing.length > 0 && <div className='ws-12 mtl pLarge tableVertical'>

                    <table className={'bgWhite table tablePresentation'}>
                        <thead>
                            <tr>
                                <th className="text-Left">UPC</th>
                                <th className="text-Left">Catalog Number</th>
                                <th className="text-Left">Release Title</th>
                                <th className="text-Left">Release Artist</th>
                                <th className="text-Left">Release Label</th>
                                <th className="text-Left">Release Format</th>
                                <th className="text-Left">CustomID</th>
                                <th className="text-Left">Tracks</th>
                            </tr>
                        </thead>
                        <tbody>

                            {assetListing?.map((list: any, index: any) => {
                                return (

                                    <>
                                        <tr className='bg-level1'>
                                            <td>{list.upc}</td>
                                            <td>{list.catalogNumber}</td>
                                            <td>{list.name}</td>
                                            <td>{list.artist}</td>
                                            <td>{list.label}</td>
                                            <td>{list.format}</td>
                                            <td>{list.customID}</td>
                                            <td>
                                                <button className='icon-btn edit btn-xs m0' onClick={() => resetDropSelect(index)} disabled={!list?.trackList?.[0]}>
                                                    <i className={selectIndex === index ? "icon-arrow-up m0" : "icon-arrow-down m0"}></i>
                                                </button>

                                            </td>
                                        </tr>

                                        {selectIndex === index && <>

                                            <tr>
                                                <td colSpan={8}>

                                                    <table className={'bgWhite table tablePresentation'}>
                                                        <thead>
                                                            <tr>
                                                                <th className="text-Left">ISRC</th>
                                                                <th className="text-Left">Main Code</th>
                                                                <th className="text-Left">Track Title</th>
                                                                <th className="text-Left">Track Artist</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        </tbody>
                                                        {list?.trackList?.map((value: any) => {

                                                            return (

                                                                <tr>
                                                                    <td>{value.ISRC}</td>
                                                                    <td>{value.mainCode}</td>
                                                                    <td>{value.trackTitle}</td>
                                                                    <td>{value.trackArtistName}</td>
                                                                </tr>
                                                            )
                                                        })
                                                        }

                                                    </table>

                                                </td>

                                            </tr></>
                                        }

                                    </>
                                )

                            })}

                        </tbody>
                    </table>
                </div>}

                {AssetType === "songs" && assetListing.length > 0 && <div className='ws-12 mtl pLarge tableVertical'>

                    <table className={'bgWhite table tablePresentation'}>
                        <thead>
                            <tr>
                                <th className="text-Left">Song Code</th>
                                <th className="text-Left">Song Title</th>
                                <th className="text-Left">Song Publishers</th>
                                <th className="text-Left">Song Writers</th>
                                <th className="text-Left">CustomID</th>
                            </tr>
                        </thead>
                        <tbody>

                            {assetListing?.map((list: any, index: any) => {
                                return (
                                    <>
                                        <tr className='bg-level1'>
                                            <td>{list.code}</td>
                                            <td>{list.title}</td>
                                            <td>{list.songPublishers}</td>
                                            <td>{list.songwriters}</td>
                                            <td>{list.customId}</td>
                                        </tr>
                                    </>
                                )

                            })}

                        </tbody>
                    </table>
                </div>}

                {(() => {
                    if (totalRows > 10) {
                        return <div className="ws-12 ptl mbl pbl"> <Pagination onPageChange={PaginationList} totalRow={totalRows} /></div>
                    }
                })()}
            </div>

        </div>
    </>)
}